import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentService } from "../../../services/component.service";
import { DisableMfaModalComponent } from "./disable-mfa-modal/disable-mfa-modal.component";
import { ResetMfaConfirmationModalComponent } from "./reset-mfa-confirmation-modal/reset-mfa-confirmation-modal.component";
import { Router } from "@angular/router";
import { AuthService } from '../../../services/auth.service';
/**
 * Authentication Component
 */
let AuthenticationComponent = class AuthenticationComponent {
    constructor(httpClient, sanitizer, router, compService, themeService, auth) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.router = router;
        this.compService = compService;
        this.themeService = themeService;
        this.auth = auth;
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.inputTextColor = '';
        this.successColor = '';
        this.accentColor = '';
        this.recoveryCodes = [];
        this.user = JSON.parse(localStorage.getItem('user'));
        this.mfaStatus = 'Disabled';
        this.validCode = true;
        this.copied = false;
        this.copiedSecret = false;
        this.completed = false;
        this.hasWallet = false;
        this.checkMFAResponse = {};
        if (!this.user || !this.user.eligible_for_wallet) {
            this.router.navigateByUrl('');
        }
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        });
    }
    ngOnInit() {
        this.auth.fetchUser().then((result) => {
            this.user = JSON.parse(localStorage.getItem('user'));
            this.mfaStatus = this.user.api_mfa_enabled == 2 ? 'In_Progress' : this.user.api_mfa_enabled ? 'Enabled' : 'Disabled';
            this.completed = this.user.api_mfa_enabled == 0 || this.user.api_mfa_enabled == 2 ? false : true;
            if (this.user.api_mfa_enabled == 2) {
                this.generateQRCode();
            }
        });
        this.httpClient.get('wallet/getaccount').subscribe((data) => {
            if (!data['accounts'] || data['accounts']['verboseId']) {
                this.hasWallet = true;
            }
        });
    }
    getMfaValues(event) {
        if (this.mfaStatus == 'Enabled') {
            event.preventDefault();
            this.compService.openModal(DisableMfaModalComponent, {
                hasWallet: this.hasWallet
            });
            this.compService.componentRef.onDestroy(() => {
                this.ngOnInit();
            });
        }
        else if (this.mfaStatus == 'In_Progress') {
            this.mfaStatus = 'Disabled';
        }
        else if (this.mfaStatus == 'Disabled') {
            this.mfaStatus = 'In_Progress';
            this.generateQRCode();
        }
    }
    generateQRCode() {
        this.httpClient.get('mfa/generateqrcode').subscribe((qrCode) => {
            this.QRCode = qrCode['qr_code'];
            this.QRCodeSecret = qrCode['secret'];
        });
    }
    enableMFA() {
        this.httpClient.get('mfa/checkmfacode?mfa_code=' + this.mfaCode).subscribe((data) => {
            if (data['isValid']) {
                if (data['recoveryCodes'] !== undefined && data['recoveryCodes'].length > 0) {
                    this.recoveryCodes = data['recoveryCodes'];
                }
                this.httpClient.post('mfa/enablemfa', null).subscribe((data) => {
                    this.user.api_mfa_enabled = 1;
                    localStorage.setItem('user', JSON.stringify(this.user));
                    this.mfaStatus = 'Enabled';
                });
            }
            else {
                this.validCode = false;
            }
        });
    }
    resetMFA() {
        this.compService.openModal(ResetMfaConfirmationModalComponent);
        this.compService.componentRef.onDestroy(() => {
            this.ngOnInit();
        });
    }
    completeMfa() {
        this.completed = true;
    }
    goToWallet() {
        this.router.navigateByUrl('wallet/cryptocurrencies');
    }
    goToHome() {
        this.router.navigateByUrl('');
    }
    copyRecoveryCodes(codes) {
        document.addEventListener('copy', (e) => {
            e.clipboardData.setData('text/plain', (codes));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        this.copied = true;
        setTimeout(() => {
            this.copied = false;
        }, 2000);
    }
    copyQRCodeSecret(secret) {
        document.addEventListener('copy', (e) => {
            e.clipboardData.setData('text/plain', (secret));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        this.copiedSecret = true;
        setTimeout(() => {
            this.copiedSecret = false;
        }, 2000);
    }
};
AuthenticationComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: Router },
    { type: ComponentService },
    { type: WebsiteThemeService },
    { type: AuthService }
];
AuthenticationComponent = __decorate([
    Component({
        selector: 'ecd-authentication',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./authentication.component.html")).default
    })
], AuthenticationComponent);
export { AuthenticationComponent };
